import {Component, OnDestroy, OnInit} from '@angular/core';
import {Subscription} from 'rxjs/Subscription';

import { UserService } from '@core/services';

@Component({
  selector: 'app-auto-login',
  templateUrl: './auto-login.component.html',
  styleUrls: ['./auto-login.component.css']
})
export class AutoLoginComponent implements OnInit, OnDestroy {

  user: any;
  subscription: Subscription;

  constructor(private _userService: UserService) {
  }

  ngOnInit() {
    this.subscription = this._userService.getUser().subscribe(user => {
      this.user = user;
    });

  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

}



// WEBPACK FOOTER //
// C:/Users/EricChanney/Apps/nexpress-angular-site/src/app/component/auto-login/auto-login.component.ts